import React from "react";

import Footer from "../components/Shared/Footer";
import PrediabetesCalculator from "../components/Shared/PrediabetesCalculator";
import BmiBriCalculator from "../components/Shared/Calculator-BMI-BRI";

const Calculator = () => {
  return (
    <div>
      <section className="breadcrumb-section pt-0">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb-contain">
                <h2>Calculator </h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <a href="/">
                        <i className="fa-solid fa-house"></i>
                      </a>
                    </li>
                    <li className="breadcrumb-item active">
                      Reducarb Benefits
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Defining Prediabetes Section */}
      <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
          <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
            <div className="col-xl-5 mb-3 ">
              <div className="custom-image-container fresh-image ">
                <img
                  src="../assets/images/Calculator/Abdominalobesitycalculator.jpg"
                  alt="Abdominal Obesity"
                  className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                />
              </div>
            </div>
            <div className="col-xl-7">
              <div className="fresh-contain p-center-left">
                <div>
                  <div className="delivery-list">
                    <div className="review-title">
                      <h1 className="font-lg mb-3">
                        Abdominal Obesity calculator
                      </h1>
                    </div>

                    <div className="font-md">
                      <div className="font-smd mb-1 fw-semibold">
                        Do I have abdominal obesity ?
                      </div>
                      <p>
                        Find the bottom of your ribs and the top of your hips.
                        Wrap a tape measure around your belly at the halfway
                        point between them (just above the belly button). Make
                        sure it is pulled tight but isn't digging into your
                        skin. Breathe out naturally and make a note of where the
                        tape measure reaches all the way around. The abdominal
                        obesity has been defined as waist circumference of more
                        than 80 cm in women and of more than 94 cm in men.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="fresh-vegetable-section section-lg-space client-section">
        <div className="container-fluid-lg">
          <div className="review-title">
            <h1 className="font-lg mb-3">Pre-diabetes Risk calculator</h1>
          </div>
          <div>
            <div className="font-smd mb-1 fw-semibold">
              Do I have Pre-diabetes ?
            </div>
            <p className="font-xsm">
              You can get a simple blood sugar test to find out if you have
              pre-diabetes. Your doctor will ask to do the fasting plasma glucose
              (FPG) test or the A1C test to diagnose pre-diabetes. Less often,
              doctors use the oral glucose tolerance test (OGTT). Results
              indicating pre-diabetes are:
            </p>
          </div>
          <div>
            <div className="row">
              <div className="col-md-4 mb-2">
                <div className="custom-image-container fresh-image-2 backcolo_blue h-100 align-items-center d-flex justify-content-center p-4">
                  <h3 className="font-md text-white">HbA1C of 5.7-6.4%</h3>
                </div>
              </div>
              <div className="col-md-4 mb-2">
                <div className="custom-image-container fresh-image-2  backcolo_blue h-100  align-items-center  d-flex justify-content-center p-4">
                  <h3 className="font-md text-white text-center ">
                    Fasting blood glucose of 100-125 mg/dL
                  </h3>
                </div>
              </div>
              <div className="col-md-4 mb-2">
                <div className="custom-image-container fresh-image-2 backcolo_blue d-flex  h-100  align-items-center  justify-content-center p-4">
                  <h3 className="font-md text-white text-center">
                    An OGTT two-hour blood glucose of 140-199 mg/dL
                  </h3>
                </div>
              </div>
            </div>

            <p className="font-xsm mt-2">
              Generally, although are other factors like age, lifestyle, family
              history, ethnicity, dietary habits are very important in assessing
              the risk of pre-diabetes, however if your Fasting blood glucose
              110-125 mg/dl and/or HbA1c between 5.7 to 6.4% they you may
              consult your doctor as you may be having pre-diabetes.
            </p>
          </div>
        </div>
      </section>
      <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
          <div className="review-title">
            <h1 className="font-lg mb-3">Body Mass Index (BMI) calculator</h1>
          </div>
          <div>
            <p className="font-xsm">
              BMI is a measurement of a person's leanness or obesity based on
              their height and weight, and is intended to quantify tissue mass.
              It is widely used as a general indicator of whether a person has a
              healthy body weight for their height. Specifically, the value
              obtained from the calculation of BMI is used to categorize whether
              a person is underweight, normal weight, overweight, or obese
              depending on what range the value falls between.
            </p>
          </div>
          <div>
            <p className="font-xsm mt-2">
              It is calculated by following formula:<br/>
              <span className="font-smd mb-1 text-black fw-semibold">
                BMI calculation – weight in kg / (height in meter)<sup>2</sup>
              </span>
            </p>
            <p className="font-xsm">
              This is the World Health Organization's (WHO) recommended body
              weight based on BMI values for adults. It is used for both men and
              women, age 20 or older.
            </p>
          </div>
          <table className="border-collapse border border-gray-400 w-full text-left w-100">
  <thead>
    <tr className="text-white font-xsm" style={{backgroundColor: "var(--theme-color1)"}}>
      <th className="border border-gray-400 px-4 py-2">Classification</th>
      <th className="border border-gray-400 px-4 py-2">BMI range - kg/m²</th>
    </tr>
  </thead>
  <tbody className="font-xsm">
    <tr>
      <td className="border border-gray-400 px-4 py-2">Severe Thinness</td>
      <td className="border border-gray-400 px-4 py-2">&lt; 16</td>
    </tr>
    <tr>
      <td className="border border-gray-400 px-4 py-2">Moderate Thinness</td>
      <td className="border border-gray-400 px-4 py-2">16 - 17</td>
    </tr>
    <tr>
      <td className="border border-gray-400 px-4 py-2">Mild Thinness</td>
      <td className="border border-gray-400 px-4 py-2">17 - 18.5</td>
    </tr>
    <tr>
      <td className="border border-gray-400 px-4 py-2">Normal</td>
      <td className="border border-gray-400 px-4 py-2">18.5 - 25</td>
    </tr>
    <tr>
      <td className="border border-gray-400 px-4 py-2">Overweight</td>
      <td className="border border-gray-400 px-4 py-2">25 - 30</td>
    </tr>
    <tr>
      <td className="border border-gray-400 px-4 py-2">Obese Class I</td>
      <td className="border border-gray-400 px-4 py-2">30 - 35</td>
    </tr>
    <tr>
      <td className="border border-gray-400 px-4 py-2">Obese Class II</td>
      <td className="border border-gray-400 px-4 py-2">35 - 40</td>
    </tr>
    <tr>
      <td className="border border-gray-400 px-4 py-2">Obese Class III</td>
      <td className="border border-gray-400 px-4 py-2">&gt; 40</td>
    </tr>
  </tbody>
</table>

        </div>
        
      </section>

      <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
          <div className="review-title">
            <h1 className="font-lg mb-3">Body Roundness Index</h1>
          </div>
          <div>
            <p className="font-xsm">
              It is widely recognized that body fat content cannot be
              characterized by BMI. For instance, among individuals with the
              same BMI, fat distribution and body composition varied
              dramatically. To better embody fat distribution, a newer
              anthropometric measure, body roundness index (BRI), was coined by
              Thomas et al, who developed elliptical models based on human body
              shape to calculate body roundness and used eccentricity to
              estimate visceral fat and total body fat percentages. Besides
              weight and height, BRI additionally considers waist circumference,
              and hence it can more comprehensively reflect visceral fat
              distribution. BRI was found to be superior over other
              anthropometric indicators in estimating the risk for various
              clinical end points, including cardiometabolic disease, kidney
              disease and all cause mortality. The normal or healthy range for
              BRI can vary, but a BRI below 4 usually indicates
              undernourishment.
            </p>
          </div>
          {/* <div>
            <div className="font-smd mb-1 text-black fw-semibold">
              BRI was calculated as 364.2 − 365.5 × √(1 − [waist circumference
              in centimeters / 2π]<sup>2</sup> / [0.5 × height in centimeters]
              <sup>2</sup>)
            </div>
          </div> */}
        </div>
      </section>

      <div>
        <BmiBriCalculator />
      </div>

      <section className="fresh-vegetable-section section-lg-space">
        <PrediabetesCalculator />
      </section>
      <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
          <div className="review-title mb-3">
            <h1 className="font-lg mb-2">References:</h1>
          </div>
          <div className="references">
            <p>
              <strong>1.</strong> <a>www.thelancet.com Vol 14 July, 2023</a>
            </p>
            <p>
              <strong>2.</strong>{" "}
              <a>https://www.cdc.gov/prediabetes/risktest/index.html</a>
            </p>
            <p>
              <strong>3.</strong>{" "}
              <a>
                Indian J Med Res 148, December 2018, pp 675-676 DOI:
                10.4103/ijmr.IJMR_1785_18
              </a>
              ;
              <a >
                Mayo Clinic: Pre-diabetes Diagnosis & Treatment
              </a>
            </p>
            <p>
              <strong>4.</strong>{" "}
              <a>
                Journal of Obesity Volume 2023, Article ID 4178121, 13 pages
              </a>
            </p>
            <p>
              <strong>5.</strong> <a>JAMA Network Open. 2024;7(6):e2415051</a>
            </p>
            <p>
              <strong>6.</strong>{" "}
              <a>Int. J. Environ. Res. Public Health 2021, 18, 281</a>
            </p>
          </div>
        </div>
      </section>

      <Footer></Footer>
    </div>
  );
};

export default Calculator;
